"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkedIndex = void 0;
var react_1 = __importStar(require("react"));
var Content_1 = __importDefault(require("./Content"));
var SideLeft_1 = __importDefault(require("./SideLeft"));
var SideRight_1 = __importDefault(require("./SideRight"));
var checkedIndex = function (val) { return val; };
exports.checkedIndex = checkedIndex;
var HomeIndex = function (props) {
    var _a = props.productList, productList = _a === void 0 ? [] : _a, title = props.title, _b = props.service, service = _b === void 0 ? [] : _b, _c = props.moreData, moreData = _c === void 0 ? {} : _c;
    var _d = (0, react_1.useState)(0), currentIndex = _d[0], setCurrentIndex = _d[1];
    /**
     * 获取左侧数据
     * @params title imgUrl
     */
    var configurationArray = [];
    productList.forEach(function (item) {
        var _a = item || {}, title = _a.title, imgUrl = _a.imgUrl, extendProps = _a.extendProps;
        configurationArray.push({
            title: title,
            imgUrl: imgUrl,
            extendProps: extendProps,
        });
    });
    /**
     * checked
     * @param index
     */
    var checked = function (index) {
        setCurrentIndex((0, exports.checkedIndex)(index));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SideLeft_1.default, { configurationArray: configurationArray, checked: checked, currentIndex: currentIndex, moreData: moreData }),
        react_1.default.createElement(Content_1.default, { currentIndex: currentIndex, productList: productList }),
        react_1.default.createElement(SideRight_1.default, { title: title, service: service })));
};
HomeIndex.displayName = 'HomeIndex';
exports.default = HomeIndex;
//# sourceMappingURL=index.js.map